import React from "react"
import ReactDOM from "react-dom"
import TimaticWidgetContainer from "./timatic-widget-container-component"

export default class TimaticWidgetContainerModule {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.modelJson = elem.dataset.modelJson && JSON.parse(elem.dataset.modelJson)
    self.init()
    return self
  }

  init() {
    const self = this
    ReactDOM.unmountComponentAtNode(self.elem)
    ReactDOM.render(<TimaticWidgetContainer {...self.modelJson} />, self.elem)
  }
}
